import { Stack } from '@mui/material';

import { ActionCard } from '@/components/layout/ActionCard/ActionCard';
import { Loader } from '@/components/progress/Loader/Loader';

export interface ProcessingViewProps {
  title: string;
  subtitle: string;
}

export function ProcessingView({ title, subtitle }: ProcessingViewProps) {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      alignSelf="center"
      width="100%"
      height="100%"
      p={4}
    >
      <ActionCard
        variant="noCard"
        icon={<Loader circularProgressProps={{ size: 32 }} />}
        heading={title}
        description={subtitle}
        sx={{ maxWidth: 400 }}
      />
    </Stack>
  );
}
